module.exports = {
  'en': {
    'HRMS62EC1': {
      '10': 'Department Code',
      '20': 'Or Emp.Code',
      '25': 'From Date',
      '26': 'To',
      '30': 'Emp. Code',
      '40': 'Emp.Name',
      '50': 'Req. Date',
      '60': 'Seq.',
      '70': 'Leave Code',
      '80': 'Leave Period',
      '90': 'Status',
      '99': 'Request for Record Leave Application',
      '100': 'Remarks',
      '110': 'Last Approver',
      '120': 'Between date',
      '130': 'To',
      '140': 'Next Approval'
    },
    'HRMS62EC2': {
      '10': 'Emp. Code',
      '20': 'Date',
      '25': 'Seq. No.',
      '27': 'Leave Application',
      '28': 'Leave Available',
      '30': 'Leave Code',
      '40': 'Detail of Leave',
      '50': 'From Date',
      '60': 'To Date',
      '70': 'From Time',
      '80': 'To Time',
      '90': 'See More Details.',
      '100': 'Leave Condition',
      '110': 'Leave Available',
      '120': 'Approve By Next Step',
      '122': 'Atach File',
      '130': 'Emp. Record',
      '140': 'Emp.Code',
      '150': 'Actual Time in-out',
      '160': 'Shift Code',
      '170': 'Working Time',
      '180': 'Day of leave',
      '200': 'Full Day',
      '210': 'Half past Day',
      '220': 'Half to Day',
      '230': 'Hours.',
      '250': 'Type of Leave',
      '260': 'Leave Limitation',
      '261': 'Per Case',
      '262': 'Per Year',
      '270': 'Day',
      '280': 'Hour',
      '290': 'Min',
      '300': 'Entitlement',
      '310': 'Actual Leave',
      '320': 'Balance',
      '330': 'Total Request',
      '340': 'More information.',
      '350': 'Number of vacation time',
      '360': 'Number of days to be pay',
      '370': 'Number of days without pay',
      '999': 'Approve By Next Step'
    },
    'HRMS62EC3': {
      '10': 'Leave Condition',
      '20': 'Leave Code',
      '30': 'Leave Count Method',
      '40': 'Eligibility Condition'
    },
    'HRMS62EC4': {
      '10': 'Leave Details',
      '20': 'Type of Leave',
      '30': 'Leave Limitation',
      '40': 'Per Case',
      '50': 'Per Year',
      '60': 'Day',
      '70': 'Hour',
      '80': 'Min',
      '90': 'Entitlement',
      '100': 'Actual Leave',
      '110': 'Balance',
      '120': 'Total Request',
      '130': 'Total Leave times',
      '140': 'Times',
      '150': 'Total Leave For This Application',
      '160': 'With Pay',
      '170': 'Without Pay'
    },
    'HRMS62EC5': {
      '10': 'Leave Details',
      '20': 'Type of Leave',
      '30': 'Leave Limitation',
      '40': 'Per Case',
      '50': 'Per Year',
      '60': 'Day',
      '70': 'Hour',
      '80': 'Min',
      '90': 'Entitlement',
      '100': 'Actual Leave',
      '110': 'Balance',
      '120': 'Total Request'
    }
  },
  'th': {
    'HRMS62EC1': {
      '10': 'หน่วยงาน',
      '20': 'หรือ รหัสพนักงาน',
      '25': 'ระหว่างวันที่',
      '26': 'ถึง',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ-นามสกุล',
      '50': 'วันที่ขอ',
      '60': 'ลำดับ',
      '70': 'รหัสการลา',
      '80': 'ช่วงวันที่ขอลา',
      '90': 'สถานะ',
      '99': 'คำร้องขอลาหยุดงาน',
      '100': 'หมายเหตุ',
      '110': 'ผู้อนุมัติล่าสุด',
      '120': 'ช่วงวันที่ตตั้งแต่',
      '130': 'ถึง',
      '140': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRMS62EC2': {
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอ',
      '25': 'ลำดับที่',
      '27': 'บันทึกใบลาหยุดงาน',
      '28': 'สิทธิการลาคงเหลือ',
      '30': 'การลาหยุดงาน',
      '40': 'รายละเอียดการลา',
      '50': 'ตั้งแต่วันที่',
      '60': 'ถึงวันที่',
      '70': 'ตั้งแต่เวลา',
      '80': 'ถึงเวลา',
      '90': 'รายละเอียดเพิ่มเติม',
      '100': 'รายละเอียดการลา',
      '110': 'สิทธการลาคงเหลือ',
      '120': 'อนุมัติโดยข้ามขั้นตอน',
      '122': 'แนบไฟล์',
      '130': 'ผู้บันทึก',
      '140': 'รหัสพนักงาน',
      '150': 'รายละเอียดเวลาปฏิบัติงาน',
      '160': 'รหัสกะ',
      '170': 'เวลาปฎิบัติงาน',
      '180': 'วันที่ลา',
      '200': 'เต็มวัน',
      '210': 'ครึ่งแรก',
      '220': 'ครึ่งหลัง',
      '230': 'กำหนดเอง',
      '250': 'ประเภทการลา',
      '260': 'การนับสิทธิ์การลา',
      '261': 'ต่อครั้ง',
      '262': 'ต่อปี',
      '270': 'วัน',
      '280': 'ชม.',
      '290': 'นาที',
      '300': 'จำนวนวันลาที่มีสิทธิ์',
      '310': 'จำนวนวันลาสะสม',
      '320': 'คงเหลือ',
      '330': 'จำนวนวันที่ขอลาสะสม',
      '340': 'ข้อมูลเพิ่มเติม',
      '350': 'จำนวนวันลาครั้งนี้',
      '360': 'จำนวนวันที่ได้รับเงินเดือน',
      '370': 'จำนวนวันที่ไม่ได้รับเงินเดือน',
      '999': 'อนุมัติโดยข้ามขั้นตอน'
    },
    'HRMS62EC3': {
      '10': 'รายละเอียดการลา',
      '20': 'รหัสการลา',
      '30': 'วิธีนับวันลา',
      '40': 'เงื่อนไขผู้มีสิทธิลา'
    },
    'HRMS62EC4': {
      '10': 'รายละเอียดการลาหยุด',
      '20': 'ประเภทการลา',
      '30': 'การนับสิทธิ์การลา',
      '40': 'ต่อครั้ง',
      '50': 'ต่อปี',
      '60': 'วัน',
      '70': 'ชม.',
      '80': 'นาที',
      '90': 'จำนวนวันลาที่มีสิทธิ์',
      '100': 'จำนวนวันลาสะสม',
      '110': 'คงเหลือ',
      '120': 'จำนวนวันที่ขอลาสะสม',
      '130': 'จำนวนครั้งที่ลาสะสม',
      '140': 'ครั้ง',
      '150': 'จำนวนวันลาครั้งนี้',
      '160': 'ได้รับเงินเดือน',
      '170': 'ไม่ได้รับเงินเดือน'
    },
    'HRMS62EC5': {
      '10': 'สิทธิการลาหยุด',
      '20': 'ประเภทการลา',
      '30': 'การนับสิทธิ์การลา',
      '40': 'ต่อครั้ง',
      '50': 'ต่อปี',
      '60': 'วัน',
      '70': 'ชม.',
      '80': 'นาที',
      '90': 'จำนวนวันลาที่มีสิทธิ์',
      '100': 'จำนวนวันลาสะสม',
      '110': 'คงเหลือ',
      '120': 'จำนวนวันที่ขอลาสะสม'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms62e.js